import {
  base_colorContentBorder,
  base_colorSurfaceSecondary,
  tag_colorTagPendingTextHover,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_4xl,
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const modal = css`
  .BaseModal-Content.popup {
    width: 640px;
    max-width: 92vw;
  }

  &.ConfirmCardAssignmentModal .BaseModal-Body {
    padding: ${spacing(10)};
    display: flex;
    flex-direction: column;
    gap: ${spacing(5)};
  }
`

export const title = css`
  margin: 0;
  ${font_4xl};
  font-family: ${font_family_weight_medium};
  font-weight: 500;
  color: ${text_colorTextPrimary};
`

export const subtitle = css`
  margin: 0;
  ${font_md};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
`

export const roleEmphasis = css`
  font-family: ${font_family_weight_medium};
  color: ${text_colorTextPrimary};
`

const card = css`
  background-color: ${base_colorSurfaceSecondary};
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${spacing(3)};
  padding: ${spacing(5)};
`

export const summaryCard = css`
  ${card};
  display: flex;
  flex-direction: column;
`

export const divider = css`
  height: 1px;
  background-color: ${base_colorContentBorder};
  margin-bottom: ${spacing(3)};
`

export const acknowledgeCard = css`
  ${card};
`

export const footer = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${spacing(5)};
  margin-top: ${spacing(2)};
`

export const cancelButton = css`
  &.Button.no-shell {
    box-shadow: none;
    color: ${text_colorTextSecondary};
  }
`

export const warningIcon = css`
  path {
    fill: ${tag_colorTagPendingTextHover};
  }
`

export default {
  modal,
  title,
  subtitle,
  roleEmphasis,
  summaryCard,
  divider,
  acknowledgeCard,
  footer,
  cancelButton,
  warningIcon,
}
